import StringHelper from "../lib/string-helper";
import {AnalyticsService} from "./analytics-service";

export class GlobalService {
    constructor() {
        this.saveUTMTags();
        this.handleOnlineChatInit();
        this.abTest();
    }

    saveUTMTags() {
        const utmTagKeys = ['source', 'campaign', 'medium', 'term', 'content'];
        const urlQueryParams = new URLSearchParams(window.location.search);

        for (const utmTagKey of utmTagKeys) {
            const utmTagValueFromQuery = urlQueryParams.get(`utm_${utmTagKey}`);

            if (!utmTagValueFromQuery) {
                continue;
            }

            const utmTagJsonDataFromStorage = localStorage.getItem(`utm${StringHelper.capitalize(utmTagKey)}`);
            const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

            if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object' && utmTagDataFromStorage.value === utmTagValueFromQuery) {
                continue;
            }

            localStorage.setItem(`utm${StringHelper.capitalize(utmTagKey)}`, JSON.stringify({
                value: utmTagValueFromQuery,
                date: Date.now()
            }));
        }
    }

    addOnlineChatEvents() {
        if (!window.HelpCrunch) {
            return;
        }

        window.HelpCrunch('onCustomerMessage', function(event) {
            if(event.detail.isFirstMessage) {
                let formCachedData = localStorage.getItem('formValues');
                formCachedData = formCachedData ? JSON.parse(formCachedData) : {};

                let lmsUserData = costorage.get('h_lmsUser');
                lmsUserData = lmsUserData ? JSON.parse(lmsUserData) : {};

                const data = Object.assign({
                    fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                    fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                    referrer: location.href
                }, formCachedData, lmsUserData);

                AnalyticsService.sendEvent('Chat', data);
            }
        });
    }

    handleOnlineChatInit() {
        if (window.HelpCrunch) {
            this.addOnlineChatEvents();
        } else {
            window.addEventListener('helpcrunch_init', () => {
                this.addOnlineChatEvents();
            });
        }
    }

    abTest() {
        AnalyticsService.onFeatureFlags((featureFlags, flagVariants) => {
            if (AnalyticsService.getFeatureFlag('black-friday-2024') === 'test') {
                document.body.classList.add('-feature-flag-test');
            } else {
                document.body.classList.add('-feature-flag-control');
            }
        });
        setTimeout(() => {
            if (!document.body.classList.contains('-feature-flag-test') && !document.body.classList.contains('-feature-flag-control')) {
                document.body.classList.add('-feature-flag-control');
            }
        }, 3000);
    }
}